import { Injectable } from '@angular/core';
import { AbpConsts, EntityDto, Rest, RestService } from '@ralba/shared';
import {
  AppendMessagesInputDto,
  AttachmentDto,
  CreatePayrollRecapInputDto,
  GetArtifactAttachments,
  GetMessages,
  MessageDto,
  PayrollRecapDto,
  PayrollRecapOperationInputDto,
  TenancyRequestDto,
  UploadArtifactAttachment,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class PurgeCompanyHttpApiService {
  constructor(private rest: RestService) {}

  public purgeCompany(params: EntityDto) {
    const request: Rest.Request<null> =
      {
        method: 'DELETE',
        url: '/api/purge-company',
        params,
      };

    return this.rest.request<
      null,
      Rest.AbpResponse<void >
    >(request);
  }
}
